export const STATS_REQUEST = 'STATS_REQUEST';
export const STATS_REQUEST_DOWNLOAD_LINK = 'STATS_REQUEST_DOWNLOAD_LINK';
export const STATS_SUCCESS = 'STATS_SUCCESS';
export const STATS_ERROR = 'STATS_ERROR';
export const STATS_EMPTY = 'STATS_EMPTY';
